const TechnicalDocument = () =>
  import(
    /* webpackChunkName: "TechnicalDocument" */ "@/components/rapsotec/technical-document/TechnicalDocument.vue"
  );

export default [
  {
    path: ":type?",
    name: "technical-document",
    component: TechnicalDocument,
  },
];
